module.exports = __webpack_public_path__ + "static/media/Helvetica.d3a3406a.svg";